(ns practitest.frontend.project-general-settings.main
  (:require
    [re-frame.core :as re-frame]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.components.project-settings-tabs :as project-settings-tabs]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components2.spinners :as spinners]
    [practitest.frontend.project-general-settings.events :as events]
    [practitest.frontend.project-general-settings.modals :as modals]
    [practitest.frontend.project-general-settings.subs :as subs]
    [practitest.frontend.project-general-settings.views :as views]))

(defn index []
  (let [data    @(re-frame/subscribe [::subs/data])
        form    @(re-frame/subscribe [::subs/form])
        errors  @(re-frame/subscribe [::subs/errors])
        saving? @(re-frame/subscribe [::subs/saving?])]
    ;; Page shell classes are shared with Project Fields
    [:div.project-fields-index-page.project-general-settings-page
     [:div.project-fields-header
      [project-settings-tabs/project-settings-tabs {}]
      [:h1.project-fields-page-title
       (get-translation "entity.tab.general" "General")]]
     (if-not data
       [:div.d-flex.justify-content-center.p-5 [spinners/mux-spinner {}]]
       [:div.project-general-settings-content
        [:div.project-general-settings-main
         [views/project-details data form errors]
         [views/modules-and-features data form]
         [views/test-runs data form]
         [views/import-api-automation data form]
         [:div.d-flex
          [buttons/button {:primary? true
                           :test-id  "general-settings-save"
                           :loading? saving?
                           :text     (get-translation "generic.button.save" "Save")
                           :on-click #(re-frame/dispatch [::events/save])}]]]
        [:div.project-general-settings-side
         [views/project-info data]]
        [modals/remove-logo-modal]
        [modals/annotation-modal]])]))

(def main-controller
  {:start (fn [_] (re-frame/dispatch [::events/fetch]))
   :stop  (fn [_] (re-frame/dispatch [::events/reset]))})
